import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=127ffc78&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=127ffc78&prod&scoped=true&lang=css"
import style1 from "./LeftMenu.vue?vue&type=style&index=1&id=127ffc78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ffc78",
  null
  
)

export default component.exports